module.exports = __webpack_public_path__ + "img/1531971929.66a542d0.jpg";